import { render, staticRenderFns } from "./GroupRules.vue?vue&type=template&id=6d58cc5c&"
import script from "./GroupRules.vue?vue&type=script&lang=js&"
export * from "./GroupRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports